
export const ArrowDownFilled = ({color="#4E4B66", size=12, className}: {color?: string, size?: number, className?: string}) => {
  return (
    <svg className={className} width={size} height={size} viewBox="0 0 6 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M1 3L3 5L5 3" fill={color}/>
    </svg> 
  );
}